import { http } from '@/http/axios.js'
// 地址树
export function getAreaTree(params) {
  return http({
    url: '/api/manage/area/tree',
    method: 'GET',
    params
  })
}

export function getProvince() {
  return http({
    url: '/api/manage/area/getProvince',
    method: 'GET'
  })
}

export function getCity(province_id) {
  return http({
    url: '/api/manage/area/getCity',
    method: 'GET',
    params: {
      province_id
    }
  })
}